import angular from 'angular';
import _ from 'lodash';

const merchantProfileStoreFactory =  function MerchantProfileStoreFactory($rootScope, $q, $log, $http, Dispatcher, StoreStates, NewBackendService, NewTokenService) {
        "ngInject";
    const merchantProfileStore = {merchant: false};
    let merchantProfileStoreState = StoreStates.STORE_EMPTY;
    const notifySwitch = () => {
      $rootScope.$broadcast("MERCHANT_PROFILE_SWITCH");
    };
    const notifyChange = () => {
      $rootScope.$broadcast("MERCHANT_PROFILE_UPDATE");
    };
    const notifyFail = () => {// eslint-disable-line no-unused-vars
      $rootScope.$broadcast("MERCHANT_PROFILE_FAIL");
    };
    const token = Dispatcher.register(action => { // eslint-disable-line no-unused-vars
      switch (action.actionType) {
        case "SWITCH_MERCHANT_PROFILE":
          if(action.data !== undefined){
            merchantProfileStore.merchant = action.data;
          } else {
            merchantProfileStore.merchant = !merchantProfileStore.merchant;
          }
          if(merchantProfileStore.merchant){
            const merchantprof = _.filter(NewTokenService.getUserContext().associatedWallets, o =>
              { return o.profile === "merchant" || o.profile === "hybrid";
            });  //passing the wallet to backend, even if hybrid profile, because BE needs it to
            $log.debug("merchantprof", merchantprof);                                                                 //populate merchantDeviceID correctly
            if(merchantprof.length > 0) {
              // NewBackendService.setWalletId(merchantprof[0].idWallet);
            } else {
              $log.error(`merchantProfileStore`,`No merchant wallet founded`);
            }
          } else {
                // NewBackendService.cleanWalletId();
          }
          notifySwitch();
          break;
        case "UPDATE_MERCHANT_PROFILE":
          merchantProfileStore.profile = action.data;
          merchantProfileStoreState = action.state;
          notifyChange();
          break;
        case "CLEAN_MERCHANT_PROFILE":
          merchantProfileStore.profile = undefined;
          merchantProfileStore.merchant = false;
          merchantProfileStoreState = StoreStates.STORE_EMPTY;
          NewBackendService.cleanWalletId();
          notifyChange();
          break;
        case "GET_MERCHANT_CONTEXT_FAIL":
          merchantProfileStore.profile = undefined;
          merchantProfileStoreState = action.state;
          notifyFail();
          break;
        default:
          break;
      }
    });
    return {
      isInvalid: () => {
        return merchantProfileStoreState === StoreStates.STORE_EMPTY ||
          merchantProfileStoreState === StoreStates.STORE_EXPIRED ||
          merchantProfileStoreState === StoreStates.STORE_FAILED_UPDATE;
      },
      isValid: () => {
        return merchantProfileStoreState === StoreStates.STORE_VALID;
      },
      isPending: () => {
        return merchantProfileStoreState === StoreStates.STORE_PENDING_UPDATE;
      },
      isMerchant: () => {
        return merchantProfileStore.merchant;
      },
      getMerchantProfile: () => {
        return angular.copy(merchantProfileStore.profile);
      },
      isEasyProfile: () => {
        const merchantprof = _.filter(NewTokenService.getUserContext().associatedWallets, o =>
         { return o.profile === "hybrid"; });
         return merchantprof.length === 1 ;
      },
      isDoubleProfle: () => {
        const wallets = NewTokenService.getUserContext().associatedWallets;
        const merchantprof = _.filter(wallets, o =>
         { return o.profile === "merchant"; });
          return wallets.length >= 2 &&merchantprof.length === 1  ;
      },
      isMultipleLR: () => {
        const businesses = NewTokenService.getBusinesses();
          return businesses && businesses.length > 1;
      },
      isMerchantOnly: () => {
        const wallets = NewTokenService.getUserContext().associatedWallets;
        if(wallets === undefined){
          return false;
        }
        const merchantprof = _.filter(wallets, o =>
         { return o.profile === "merchant"; });
          return wallets.length === 1 &&merchantprof.length === 1  ;
      },
      expireMerchantProfile: () => {
        merchantProfileStoreState = StoreStates.STORE_EXPIRED;
      }

    };
  }

export default merchantProfileStoreFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/merchantProfileStore.factory.js
 **/